import {
  Tv,
  Home,
  Shield,
  Bookmark,
  UserPlus,
  Settings,
  Briefcase,
  AlertCircle,
  MessageSquare,
} from 'react-feather';
import {
  openOldModalAction,
  closeOldModalAction,
} from '../../store/modal/modalActions';
import { NavigationEnum } from './Navigation.enum';
import Toast from '../../components/shared/Toast/Toast';
import { AUTH_NAMESPACE } from '../../store/Auth/authReducer';
import { ModalComponentEnum } from '../../store/modal/modalTypes';
import { ToastTypeEnum } from '../../components/shared/Toast/toast-type.enum';

const onOpenServiceCallModal = (dispatch, state, history, t) => {
  const profile = state[AUTH_NAMESPACE];

  if (!profile.profile.permissions.serviceCall) {
    Toast(
      ToastTypeEnum.ERROR,
      t('NO_PERMISSION_TEXT', { operation: t('OPEN_SERVICE_CALL_TEXT') })
    );
    return;
  }

  if (!profile.profile.phone) {
    return dispatch(
      openOldModalAction(
        ModalComponentEnum.QUESTION_FAIL_OPEN_SERVICE_CALL_MODAL,
        { isFullSizeOnMobile: true },
        {},
        () => {
          history.push('/account-settings');
          dispatch(closeOldModalAction());
        }
      )
    );
  }

  dispatch(
    openOldModalAction(
      ModalComponentEnum.NEW_SERVICE_CALL_MODAL,
      { isFullSizeOnMobile: true },
      {},
      () => {}
    )
  );
};

const vertical = (
  isCompanyOwner,
  setShowComingSoon,
  isSuperAdmin,
  isLoggedIn,
  isGuard,
  location
) => {
  if (isGuard) {
    return [
      {
        id: 'guests',
        title: 'MY_VISITORS',
        icon: <UserPlus />,
        navLink: NavigationEnum.INVITE_GUEST,
      },
      {
        id: 'all guests',
        title: 'ALL_GUESTS',
        icon: <Shield size={20} />,
        navLink: NavigationEnum.ALL_GUESTS,
      },
    ];
  }

  return isLoggedIn
    ? [
        // {
        //   id: 'showComingSoon',
        //   title: 'Show coming soon',
        //   action: setShowComingSoon,

        // },
        {
          id: 'dashboards',
          title: 'DASHBOARDS_MAIN_BREADCRUMBS',
          icon: <Home size={20} />,
          navLink: NavigationEnum.DASHBOARDS,
        },
        {
          id: 'bookings',
          title: 'MY_ACTIVITIES_BREADCRUMBS',
          icon: <Bookmark size={20} />,
          navLink: NavigationEnum.MY_ACTIVITIES,
        },
        {
          id: 'book a room',
          title: 'BOOK_A_ROOM',
          icon: <i className="icon-meeting-board" />,
          navLink: NavigationEnum.BOOK_A_ROOM,
        },
        location.id !== 7 || isSuperAdmin
          ? {
              id: 'book a lounge',
              title: 'BOOK_LOUNGE',
              icon: <Tv size={20} />,
              navLink: NavigationEnum.BOOK_A_LOUNGE,
            }
          : {},
        location.id === 7 || isSuperAdmin
          ? {
              id: 'book a roof top',
              title: 'BOOK_A_ROOF_TOP',
              icon: <i className="icon-meeting-board" />,
              navLink: NavigationEnum.BOOK_A_ROOF_TOP,
            }
          : {},

        location.id !== 7 || isSuperAdmin
          ? {
              id: 'book gym',
              title: 'BOOK_GYM',
              icon: <i className="icon-dumbbell" />,
              navLink: NavigationEnum.BOOK_A_FITNESS,
            }
          : {},
        // {
        //   id: 'subscriptions management',
        //   title: 'SUBSCRIPTION_NAV_TITLE',
        //   icon: <Book size={20} />,
        //   navLink: NavigationEnum.SUBSCRIPTION_MANAGEMENT,
        // },
        location.extraInformation.restaurantLink
          ? {
              id: 'restaurant',
              title: 'RESTAURANT',
              icon: <i className="fa-solid fa-utensils" />,
              action: () =>
                window.open(
                  location.extraInformation.restaurantLink,
                  '_blank',
                  'noopener,noreferrer'
                ),
            }
          : {},
        location.id === 6 || isSuperAdmin
          ? {
              id: 'events',
              title: 'EVENTS',
              icon: <i className="icon-glass-martini" />,
              navLink: NavigationEnum.EVENTS,
            }
          : {},
        location.id !== 7 || isSuperAdmin
          ? {
              id: 'guests',
              title: 'MY_VISITORS',
              icon: <UserPlus />,
              navLink: NavigationEnum.INVITE_GUEST,
            }
          : {},
        {
          id: 'support events',
          title: 'SUPPORT_EVENTS',
          icon: <MessageSquare size={20} />,
          navLink: NavigationEnum.SUPPORT_EVENTS,
        },
        // {
        //   id: 'contact support',
        //   title: 'CONTACT_SUPPORT_BUTTON',
        //   icon: <MessageSquare size={20} />,
        //   action: (dispatch, state, history, t) =>
        //     onOpenServiceCallModal(dispatch, state, history, t),
        // },
        {
          id: 'faq',
          title: 'FAQ',
          icon: <AlertCircle size={20} />,
          navLink: NavigationEnum.FAQ,
        },
        isCompanyOwner
          ? {
              id: 'my company',
              title: 'MY_COMPANY',
              icon: <Briefcase size={20} />,
              navLink: NavigationEnum.MY_COMPANY,
            }
          : {
              disabled: true,
            },

        location.extraInformation.parkingLink
          ? {
              id: 'parking',
              title: 'PARKING_TAB_LABEL',
              icon: <i className="fa-solid fa-parking" />,
              action: () =>
                window.open(
                  location.extraInformation.parkingLink,
                  '_blank',
                  'noopener,noreferrer'
                ),
            }
          : {},

        isSuperAdmin
          ? {
              id: 'all guests',
              title: 'ALL_GUESTS',
              icon: <Shield size={20} />,
              navLink: NavigationEnum.ALL_GUESTS,
            }
          : {
              disabled: true,
            },
      ].filter((item) => item.id)
    : [];
};

export default vertical;
